export enum SoftPromptChoiceType {
    Invisible,
    Visible,
    VisibleDefault,
}
